import {DecimalPipe} from '@angular/common';
import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiModulesService} from 'src/app/api-modules.service';
import {NgbdSortableHeader, SortEvent} from 'src/app/shared/directives/NgbdSortableHeader';
import {TableService} from 'src/app/shared/service/table.service';
import {LISTPAGEDB, ListPagesDB} from 'src/app/shared/tables/list-pages';

@Component({
    selector: 'app-list-page',
    templateUrl: './list-page.component.html',
    styleUrls: ['./list-page.component.scss']
})
export class ListPageComponent implements OnInit {
    public selected = [];
    public searchText;
    public editID: any;
    visible: any = true;
    public username = [];

    countries = [];
    data: any[] = [];
    filterParams: any = {};
    sortField: any = '';
    sortOrder: any = '';
    searchQuery: any = '';

    // Pagination
    currentPage = 1;
    total = 0;

    constructor(private apiModulesService: ApiModulesService) {

    }

    @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

    onSort({column, direction}: SortEvent) {

        this.headers.forEach((header) => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });
        this.sortField = column;
        this.sortOrder = direction;
        this.loadData();
    }

    onSelect(selected) {
        console.log(selected.target.value);
        this.filterParams.page = 1;
        this.loadData();
    }

    onSelectOwned(selected) {
        console.log(selected.target.value);
        this.filterParams.page = 1;
        this.loadData();
    }


    ngOnInit(): void {
        this.filterParams.country_id = '';
        this.getCountriesName();
        this.loadData();
    }

    loadData() {
        console.log(this.filterParams);
        this.apiModulesService.getData('telegram/channel/lists', this.filterParams, this.sortField, this.sortOrder, this.searchQuery)
            .subscribe((response: any) => {
                this.data = response.data;
                this.currentPage = response.current_page;
                this.total = response.total;
            });
    }

    clearFilter() {
        this.filterParams.page = 1;
        this.filterParams.country_id = '';
        this.filterParams.name = '';
        this.filterParams.channel_id = '';
        this.filterParams.owned = '';
        this.filterParams.watch_messages_for_scrapping_user = '';
        this.loadData();
    }

    applySort() {
        this.loadData();
    }

    applySearch() {
        this.filterParams.page = 1;
        this.loadData();
    }

    public getCountriesName() {
        this.apiModulesService.get('telegram/country/list').subscribe((data) => {
            this.countries = data;
        });
    }

    /**
     * Write code on Method
     *
     * @return response()
     */
    pageChangeEvent(event: number) {
        this.currentPage = event;
        this.filterParams.page = this.currentPage;
        this.loadData();
    }

    public editChannels(id) {
        this.editID = id;
        this.visible = false;
    }

    childEmitted(data: any) {
        // console.log(data);
        this.visible = data;
        this.loadData();

    }
}
